import { t } from 'ember-intl';
import CourseCashTag from '../../../tas/course-cash-tag.gts';
import type { TasProgramTemplateExtension as TASProgramTemplateModel } from 'tio-data/data/resources/tas-program-template.ext';
import type { TOC } from '@ember/component/template-only';

export interface TioHeaderSignature {
  Args: {
    headerBeginning?: string;
    highlightText?: string;
    headerEnd?: string;
    description?: string;
    template?: TASProgramTemplateModel;
  };
  Element: HTMLDivElement;
}

const TioHeader: TOC<TioHeaderSignature> = <template>
  <div class="prose lg:prose-lg max-w-none">
    <h2>
      <span class="tio-fg-secondary">
        {{@headerBeginning}}
        <span class="text-midnight">
          {{if @highlightText @highlightText}}
        </span>
        {{@headerEnd}}
      </span>
    </h2>
    {{#if @template}}
      <CourseCashTag
        @isDirectPayProgram={{@template.isDirectPayProgram}}
        @size="sm"
        class="not-prose -mt-6"
      >
        <:beforeTag>
          <span>
            {{t "common.tas.course_cash.eligible_for"}}
          </span>
        </:beforeTag>
      </CourseCashTag>
    {{/if}}
    <p>{{@description}}</p>
  </div>
</template>;

export default TioHeader;
